
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import EditReturnOrder from '@/views/front/abroad/edit-returnorder.vue'
    import appconst from '@/lib/appconst';
    import { routers } from '@/router/router'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    import moment from 'moment'
    Vue.use(Preview);


    class PageOrderRequest extends PageRequest {
        //WarehouseOrderStatus?: number ;
        //WarehouseOrderPackageStatus?: number;
        orderStatus?: number;
        packageStatus?: number;
        SearchInfo: string;
        BeginTime?: Date;
        EndTime?: Date;
        PlatformType?: number;
        isUrgent?: boolean;
        tradeNo: string;
        productorderStatu?: number;
        constructor() {
            super();
            this.orderStatus = null;
            this.packageStatus = null;
            this.isUrgent = null;
            //this.PlatformType = 0;
        }
    }


    @Component({
        name: "frontstockorder",
        components: { EditReturnOrder }
    })
    export default class Orders extends AbpBase {
        pagerequest: PageOrderRequest = new PageOrderRequest();
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        orderStatus = Enums.getEnum(Enums.WarehouseOrderStatus, true);
        packageStatus = Enums.getEnum(Enums.WarehouseOrderPackageStatus, true);
        PlatformType = Enums.getEnum(Enums.PlatformType, true);
        editreturnorderModel: boolean = false;
        urgentStatus = Enums.getEnum(Enums.WhetherHandleStatus, true);
        productorderList = Enums.getEnum(Enums.ProductOrderStatus, true);
        get list() {
            return this.$store.state.frontstockorder.list;
        };
        get loading() {
            return this.$store.state.frontstockorder.loading;
        }
        pageChange(page: number) {
            this.$store.commit('frontstockorder/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('frontstockorder/setPageSize', pagesize);
            this.getpage();
        }
        async searchPage() {
            this.$store.state.frontstockorder.currentPage = 1;
            this.getpage();
        }
        async InputReturnOrder(data: any) {
            this.$store.state.fontoverseasreturnorders.id = data.id;
            this.$store.state.fontoverseasreturnorders.orderNumber = data.orderNumber;
            this.editreturnorderModel = true;
        }
        async getpage() {
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

            await this.$store.dispatch({
                type: 'frontstockorder/getAll',
                data: this.pagerequest
            });

            var _this: any = this;
            _this.$previewRefresh();
        }
        get pageSize() {
            return this.$store.state.frontstockorder.pageSize;
        }
        get totalCount() {
            return this.$store.state.frontstockorder.totalCount;
        }
        get currentPage() {
            return this.$store.state.frontstockorder.currentPage;
        }
        async operationData(name: any, data: any) {
            if (name == '撤销') {
                await this.$store.dispatch({
                    type: 'frontstockorder/CancleStockOrder',
                    data: { stockOrderId: data.id }
                });
                this.getpage();
            } else if (name == '标记为正常') {
                await this.$store.dispatch({
                    type: 'frontstockorder/normalOrder',
                    data: { stockOrderId: data.id }
                });
                this.getpage();
            } else if (name == '查看详情') {
                await this.$store.dispatch({
                    type: 'frontstockorder/getOrder',
                    data: { stockOrderId: data.id }
                });
                this.$store.state.frontstockorder.orderStatus = data.orderStatus;
                this.$store.state.frontstockorder.packageStatus = data.packageStatus;
                this.$router.push({ name: 'stockorderDetail' });
            } else if (name == '标记为急单') {
                var id = data.id;
                this.$Modal.confirm({
                    title: "标记为急单", content: "确认将此单标记为急单？", onOk: async () => {
                        await this.$store.dispatch({
                            type: 'frontstockorder/urgentOrder',
                            data: { stockOrderId: id }
                        });
                        this.getpage();
                    }
                });
            }
        }

        columns = [
            {
                title: '仓储名称',
                key: 'storeName',
                width: 150,
            }, {
                title: '订单编号',
                key: 'orderNumber',
                width: 150,
            }, {
                title: '订单状态',
                width: 100,
                key: 'orderStatus',
                render: (h: any, params: any) => {
                    var warehouseNote = params.row.warehouseNote;
                    if (warehouseNote) {
                        warehouseNote = "(" + warehouseNote + ")";
                    }
                    else {
                        warehouseNote = "";
                    }
                    return h('div', [h('p', Enums.WarehouseOrderStatus.filter(function (item) { return item.value == params.row.orderStatus })[0].name), [h('p', { style: { color: 'red' } }, warehouseNote)]]
                    )
                }
            },
            {
                title: '产品订单状态',
                width: 80,
                key: 'productOrderStatus',
                render: (h: any, params: any) => {
                    var color = 'red';
                    if (params.row.productOrderStatus == 3 || params.row.productOrderStatus == 4) {
                        color = 'green';
                    }
                    if (params.row.productOrderStatus != 2) {
                        return h('div', [h('p', { style: { color: color } }, Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name)])
                    }
                    else {
                        return h('span', Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name,
                        )
                    }

                }
            },
            {
                title: '异常图片',
                key: 'abnormalImageUploadGuid',
                width: 95,
                render: (h: any, params: any) => {
                    if (params.row.abnormalImageUploadGuid) {
                        var data = { imageGuid: params.row.abnormalImageUploadGuid, url: null };
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: "yc_" + params.row.id,
                                "preview-text": params.row.orderNumber + "异常图片"
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            {
                title: '备注',
                width: 200,
                key: 'reMark',
                render: (h: any, params: any) => {
                    return h('div', [h('span', { style: { color: 'red' } }, params.row.reMark)]
                    )
                }
            }, {
                title: '订单时效',
                width: 120,
                key: 'orderPayTime',
                render: (h: any, params: any) => {
                    var info = "";
                    var color = "red";
                    if (params.row.orderPayTime) {
                        var currentTime: any = new Date();
                        var payTime: any = new Date(params.row.orderPayTime);
                        var timeDifferenceInHours = (currentTime - payTime) / (60 * 60 * 1000);
                        timeDifferenceInHours = Math.round(timeDifferenceInHours * 10) / 10;
                        if (timeDifferenceInHours < 90) {
                            color = "green";
                        }
                        info = timeDifferenceInHours.toString();

                    }
                    return h('h3', { style: { color: color, display: "inline-block" } }, info);
                }
            }, {
                title: '包裹状态',
                width: 90,
                key: 'packageStatus',
                render: (h: any, params: any) => {
                    return h('span', Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name);
                }
            }, {
                title: '创建时间',
                key: 'createTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
                }
            }, 
            {
                title: '商品信息',
                width: 300,
                key: 'productInfos',
                render: (h: any, params: any) => {
                    var _this = this;
                    var a = "";
                    if (params.row.reMark) {
                        a = 'red';
                    }
                    else {
                        a = 'dark';
                    }
                    return h('div', [
                        h('ul', params.row.productInfos.map(item => {
                            var data = { imageGuid: item.productImgGuid, url: null };
                            var url = "";
                            if (item.productImgGuid.indexOf("http") != -1) {
                                url = item.productImgGuid;
                            }
                            else {
                                this.$store.commit('expressuserinfo/getImgUrl', data);
                                url = data.url;
                            }
                            return h('li', {
                            }, [
                                h('img', {
                                    style: {
                                        width: "50px",
                                        height: "50px",
                                        verticalAlign: "middle"
                                    },
                                    attrs: {
                                        src: url,
                                        preview: "tp_" + item.stockOrderProductId,
                                        "preview-text": item.stockOrderProductId + "img"

                                    }
                                }), (item.productName + "-" + item.productSku), h('font', { style: { color: "red" } }, '*'), item.count])
                        })), h('h4', { style: { color: a } }, "备注：" + (params.row.reMark == null ? "" : params.row.reMark))

                    ])

                }
            },
            {
                title: '平台物流号',
                key: 'tradeNo',
                width: 130,
            },
            {
                title: '退件订单编号',
                width: 120,
                key: 'returnNumber',
            },
            {
                title: '送仓时间',
                key: 'arriveWarehouseTime',
                width: 120,
                render: (h: any, params: any) => {
                    return h('span', params.row.arriveWarehouseTime ? DateUtils.formatLongDate(new Date(params.row.arriveWarehouseTime)) : '');
                }
            },
            {
                title: '打包袋数量',
                key: 'sackNums',
                width: 80,
            },
            {
                title: '基本SKU数量',
                key: 'baseSkuNums',
                width: 80,
            },
            {
                title: '打包袋金额',
                key: 'sackTotalAmount',
                width: 80,
            },
            {
                title: 'SKU金额',
                key: 'skuTotalAmount',
                width: 80,
            }, {
                title: '原始信息',
                key: 'isCombination',
                width: 230,
                render: (h: any, params: any) => {
                    if (!params.row.combinationProductInfos || params.row.combinationProductInfos.length === 0) {
                        return h('span', { style: { color: '#c5c8ce' } }, '');
                    }

                    return h('div', params.row.combinationProductInfos.map((item: any) => {
                        return h('div', {
                            style: {
                                marginBottom: '4px',
                                fontSize: '12px',
                                lineHeight: '1.4'
                            }
                        }, [
                            h('span', {
                                style: {
                                    color: '#515a6e',
                                    fontWeight: 'bold'
                                }
                            }, item.productNo || '未知'),
                            h('font', {
                                style: {
                                    color: 'red',
                                    margin: '0 2px'
                                }
                            }, '*'),
                            h('span', {
                                style: {
                                    color: '#808695'
                                }
                            }, `${item.count || 0}`)
                        ]);
                    }));
                }
            }, {
                title: '操作',
                width: 120,
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var _this = this;
                    var menu = [];
                    var data = params.row;
                    if (params.row.orderStatus == -1 ) {
                        menu.push("撤销");
                    }
                    if (params.row.orderStatus == -1) {
                        menu.push("标记为正常");
                    }
                    if (params.row.orderStatus == 0 && params.row.packageStatus != 5 && params.row.orderPayTime) {

                        var currentTime: any = new Date();
                        var payTime: any = new Date(params.row.orderPayTime);
                        var timeDifferenceInHours = (currentTime - payTime) / (60 * 60 * 1000);
                        timeDifferenceInHours = Math.round(timeDifferenceInHours * 10) / 10;
                        if (timeDifferenceInHours >= 85) {
                          //  menu.push("标记为急单");
                        }
                    }
                    menu.push("查看详情");
                    return h('div', [
                        h('Dropdown', {
                            props: {
                                transfer: true,
                                trigger: 'click',
                            },
                            on: {
                                'on-click': (name) => {
                                    _this.operationData(name, params.row);
                                }
                            }

                        }, [
                            h('Button',
                                {
                                    domProps: {
                                        innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                                    },
                                    props: {
                                        type: 'primary',
                                    },
                                    style: {
                                        marginTop: '5px',
                                        height: '30px',
                                        width: '85px',
                                    },

                                }),
                            h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                                return h('DropdownItem', { props: { name: item } }, item)
                            })
                            )]),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '85px',
                                display: (data.packageStatus == 4 && data.orderStatus == 0) ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                    this.InputReturnOrder(data);

                                }
                            }

                        }, "编辑退件订单"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '85px',
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    if (params.row.pdfGuid && params.row.pdfGuid.length > 1) {
                                        this.$store.commit('frontstockorder/getPdf', {
                                            pdfGuid: data.pdfGuid,
                                            orderNumber: data.orderNumber
                                        });
                                    }
                                }
                            }

                        }, "查看PDF"),

                    ]);

                }
            }]
        async created() {
            //var abnormal = abp.getQueryVariable("abnormal");
            //if (abnormal && abnormal == 'true') {
            //    this.pagerequest.orderStatus = -1;
            //}
            //this.getpage();
        }
    }
